<template>
  <div class="captcha">
    <!-- <aliVerification></aliVerification> -->
  </div>
</template>
<script>
import captcha from "@/assets/js/captcha.js";
export default {
  name: 'captcha',
  data () {
    return {
      type:2
    }
  },
  computed: {
  },
  components: {
    // aliVerification:{
    //   render(createElement){
    //     const self = this;
    //     return createElement('script',{
    //       attrs:{
    //         type:"text/javascript",
    //         src:"https://ssl.captcha.qq.com/TCaptcha.js"
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    getQueryVariable(item){
    var sValue = window.location.href.match(new RegExp("[\?\&]" + item + "=([^\&]*)(\&?)", "i"));
    return sValue ? sValue[1] : sValue;
    }
  },
  mounted () {
    // console.log(captcha)
    //   .replace(/[&\|\\\*^%$/#@\-]/g,"")
    var _t = this;
    var width = !!_t.getQueryVariable('width')?_t.getQueryVariable('width').replace(/[&\|\\\*^%$/#@\-]/g,""):800;
    var height = !!_t.getQueryVariable('height')?_t.getQueryVariable('height').replace(/[&\|\\\*^%$/#@\-]/g,""):800;
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
    var captcha1 = new TencentCaptcha('2039739188', function(res) {
        if (isIos) {
             if(res.ret==2){
                // window.location.validateCancel()
                window.webkit.messageHandlers.validateCancel.postMessage({"oneParam":"cancel"});
            }else{
                // window.location.validateSuccess(res.ticket,res.randstr);
                let data= {
                  ticket:res.ticket,
                  randstr:res.randstr
                }
                window.webkit.messageHandlers.validateSuccess.postMessage({"oneParam":data});
            }
        } else {
            if(res.ret==2){
                App.validateCancel()
            }else{
                App.validateSuccess(res.ticket,res.randstr);
            }
        }
        },
        {
            needFeedBack:false,
            sdkOpts:{"width": width, "height": height},
            ready:(res)=>{
                var {sdkView:{height,width}} = res;
            }
        }
    );
    captcha1.show(); // 显示验证码
  },
  created () {

  },
  beforecreate(){
  }
}
</script>
<style lang="scss" scoped>

</style>

